export const HOME = "/";
export const SIGNIN = "/signin";
export const CREATE_ACCOUNT = "/signin/create-account";
export const WELCOME_BACK = "/signin/welcome-back";
export const SIGNIN_WITH_PASSWORD = "/signin/with-password";
export const SIGNIN_WITH_MAGIC_LINK = "/signin/magic-link";
export const DASHBOARD = "/dashboard";
export const CREATE_PASSWORD = "/signin/create-password";
export const CHECK_EMAIL = "/signin/check-email";
export const PENDING_PROFILE = "/signin/pending-profile";
export const SIGNIN_REVIEW_INFO = "/signin/review-info";
export const FEEDBACK = "/feedback";
export const CREATE_ASSESSMENT = "/dashboard/assessments/create-assessment";
export const CONFIGURE_ASSESSMENT =
  "/dashboard/assessments/:assessmentId/configure";
export const ASSESSMENTS = "/dashboard/assessments";
export const ASSESSMENT_MONITORING =
  "/dashboard/assessments/:assessmentId/monitoring";
export const COMPLETE_PROFILE = "/signin/complete-profile";
export const FEEDBACKS = "/dashboard/feedbacks";
export const MY_FEEDBACKS = "/dashboard/feedbacks/my-feedbacks";
export const FEEDBACKS_TO_PROVIDE = "/dashboard/feedbacks/to-provide";
export const TEAM = "/dashboard/team";
export const PEOPLE = "/dashboard/people";
export const EMPLOYEE_MONITOR = PEOPLE + "/:id";
export const EMPLOYEE_DETAILED_RESULTS = EMPLOYEE_MONITOR + "/detailed-result";
export const SETTINGS = "/dashboard/settings";
export const ACCOUNT = "/dashboard/account";
export const EMPLOYEE_FEEDBACK_MONITOR = FEEDBACKS + "/:id";
export const EMPLOYEE_FEEDBACK_DETAILED_RESULT =
  FEEDBACKS + "/:id/detailed-result";
export const TERMS_OF_SERVICE = "/terms-of-service";
export const PRIVACY = "/privacy-policy";
